import { makeVar } from '@apollo/client/cache';
import { OrderStep } from 'models/workflow-step';

// What remains of the legacy lab order flow's state: the workflow step picker still reads it.
export const orderStepVar = makeVar<OrderStep>({} as OrderStep);
